import * as Sentry from "@sentry/react";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import {
  persistQueryClientRestore,
  persistQueryClientSubscribe,
} from "@tanstack/react-query-persist-client";

export const GC_TIME_MS = 24 * 60 * 60 * 1_000;

/** TanStack Query のグローバルクライアント（staleTime: 30s, retry: 1） */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: GC_TIME_MS,
      retry: 1,
    },
  },
  queryCache: new QueryCache({
    onError: (error) => Sentry.captureException(error),
  }),
  mutationCache: new MutationCache({
    onError: (error) => Sentry.captureException(error),
  }),
});

/** localStorage にキャッシュを永続化する persister */
export const queryPersister = createSyncStoragePersister({
  storage: window.localStorage,
  key: "listee-query-cache",
});

const persistOptions = {
  queryClient,
  persister: queryPersister,
  maxAge: GC_TIME_MS,
  buster: "v1",
};

/**
 * 永続化キャッシュを復元し、以降の変更の保存を開始する。
 * router の beforeLoad からキャッシュを参照できるよう、初回描画より前に呼ぶ
 * （PersistQueryClientProvider は useEffect で復元するため beforeLoad に間に合わない）。
 */
export const restoreQueryCache = async (): Promise<void> => {
  try {
    await persistQueryClientRestore(persistOptions);
  } catch (error) {
    Sentry.captureException(error);
  }
  persistQueryClientSubscribe(persistOptions);
};
